import TopMenu from '../components/TopMenu';
import BottomMenu from '../components/BottomMenu';
import { Row, Col, Container, Image } from 'react-bootstrap';
import P220 from '../images/peterbilt/Peterbilt_220.png';
import P520 from '../images/peterbilt/Peterbilt_520.webp';
import P535 from '../images/peterbilt/Peterbilt_535.jpg';
import P536 from '../images/peterbilt/Peterbilt_536.webp';
import P537 from '../images/peterbilt/Peterbilt_537.jpg';
import P548 from '../images/peterbilt/Peterbilt_548.webp';
import P567 from '../images/peterbilt/Peterbilt_567.webp';
import P579 from '../images/peterbilt/Peterbilt_579.jpg';
import P589 from '../images/peterbilt/Peterbilt_589.webp';

function Peterbilt() {
    return (
        <div>
            <TopMenu />

            <Container>
                <h2 className='htitleb text-center'>Peterbilt</h2>
                <div id="truck-box">
                    <Row>
                        <Col md={6}>
                            <Image
                                src={P220}
                                width={'100%'}
                                fluid
                                rounded
                            />
                        </Col>
                        <Col>
                            <h3>Model 220</h3>
                            <p>The Model 220 is Peterbilt’s solution for pickup and delivery, beverage and refuse applications. 
                                Designed for driver productivity and uptime, the 220 features excellent visibility, an ergonomic 
                                interior and multiple options for easy upfit. With low chassis weight, the 220 is perfect for high
                                -volume payloads, while the standard Allison automatic transmission and air disc brakes deliver 
                                excellent driveability and performance. </p>
                            <ul>
                                <li>PACCAR PX-7</li>
                                <li>Clear Rail Package Available</li>
                                <li>Right-Hand Drive Configuration Available</li>
                                <li>Collision Mitigation Available</li>
                            </ul>
                        </Col>
                    </Row>
                </div>
                <br />
                <div id="truck-box">
                    <Row>
                        <Col md={6}>
                            <Image
                                src={P520}
                                width={'100%'}
                                fluid
                                rounded
                            />
                        </Col>
                        <Col>
                            <h3>Model 520</h3>
                            <p>The Model 520 is built to withstand the harsh demands of the refuse industry. 
                                No matter the application, the Model 520 is designed to get the job done day in and day out. </p>
                            <ul>
                                <li>Paccar MX-11</li>
                                <li>Redesigned gauge cluster with 7-inch digital display</li>
                                <li>Bendix Fusion side object detection</li>
                                <li>LED headlamps</li>
                                <li>Electronic Stability Control (ESC)</li>
                            </ul>
                        </Col>
                    </Row>
                </div>
                <br />
                <div id="truck-box">
                    <Row>
                        <Col md={6}>
                            <Image
                                src={P535}
                                width={'100%'}
                                fluid
                                rounded
                            />
                        </Col>
                        <Col>
                            <h3>Model 535</h3>
                            <p>The New Model 535 is designed specifically for non-CDL applications up to 19,500 lbs. Ideal for 
                                lease and rental applications, the Model 535 provides an easy-to-drive, efficient vehicle for 
                                all drivers. The Model 535 features up to a 55-degree wheel cut, allowing drivers to easily maneuver 
                                in congested urban environments, as well as tight loading and unloading conditions. </p>
                            <ul>
                                <li>PACCAR PX-7 or CNG</li>
                                <li>Spacious, quiet interior</li>
                                <li>GVWR 19,500 lbs</li>
                                <li>50, 60, 70, 80, & 100 gallon fuel tank options</li>
                            </ul>
                        </Col>
                    </Row>
                </div>
                <br />
                <div id="truck-box">
                    <Row>
                        <Col md={6}>
                            <Image
                                src={P536}
                                width={'100%'}
                                fluid
                                rounded
                            />
                        </Col>
                        <Col>
                            <h3>Model 536</h3>
                            <p>The New Model 536 is purpose-built to get the job done in non-CDL applications up to 26,000 lbs. 
                                Ideal for pick-up and delivery applications, the Model 536 is easy-to-drive and efficient. 
                                The Model 536 is built to stay productive day after day, year after year. </p>
                            <ul>
                                <li>PACCAR PX-7 or PX-9</li>
                                <li>GVWR 26,000 lbs</li>
                                <li>50, 60, 70, 80, & 100 gallon fuel tank options</li>
                                <li>Flat roof or 78” Curved Roof options</li>
                            </ul>
                        </Col>
                    </Row>
                </div>
                <br />
                <div id="truck-box">
                    <Row>
                        <Col md={6}>
                            <Image
                                src={P537}
                                width={'100%'}
                                fluid
                                rounded
                            />
                        </Col>
                        <Col>
                            <h3>Model 537</h3>
                            <p>The New Model 537 is available as a Class 7 truck or tractor with a GVWR up to 33,000 lbs. 
                                It is highly versatile and can be configured to exceed the demands of many vocational applications. 
                                Built for big jobs.  </p>
                            <ul>
                                <li>PACCAR PX-7, PX-9 or CNG</li>
                                <li>GVWR 26,000 lbs</li>
                                <li>50, 60, 70, 80, & 100 gallon fuel tank options</li>
                                <li>Flat roof or 78” Curved Roof options</li>
                            </ul>
                        </Col>
                    </Row>
                </div>
                <br />
                <div id="truck-box">
                    <Row>
                        <Col md={6}>
                            <Image
                                src={P548}
                                width={'100%'}
                                fluid
                                rounded
                            />
                        </Col>
                        <Col>
                            <h3>Model 548</h3>
                            <p>The New Model 548 is a rugged workhorse, built to exceed the demands of Class 8 specialty 
                                applications. With its best-in-class durability and wide range of optional content, the Model 
                                548 is designed to handle heavier vocational jobs.</p>
                            <ul>
                                <li>PACCAR PX-7, PX-9 or CNG</li>
                                <li>All-aluminum, light weight cab</li>
                                <li>Quiet, comfortable ergonomic interior</li>
                                <li>GVWR Up to 66,000 lbs</li>
                                <li>50, 60, 70, 80, & 100 gallon fuel tank options</li>
                                <li>74” Flat roof or 78” Curved Roof options</li>
                            </ul>
                        </Col>
                    </Row>
                </div>
                <br />
                <div id="truck-box">
                    <Row>
                        <Col md={6}>
                            <Image
                                src={P567}
                                width={'100%'}
                                fluid
                                rounded
                            />
                        </Col>
                        <Col>
                            <h3>Model 567</h3>
                            <p>The Model 567 is a workhorse ready to take on the toughest challenges. New product enhancements
                                 have made the Model 567 even better. </p>
                            <ul>
                                <li>PACCAR MX-13 or MX-11</li>
                                <li>15-inch digital display, state-of-the-art driver interface</li>
                                <li>Enhanced electrical system simplifies integration</li>
                                <li>Wide ergonomic aluminum cab</li>
                                <li>Enhanced visibility</li>
                                <li>Easier access and serviceability</li>
                                <li>Rugged and reliable</li>
                            </ul>
                        </Col>
                    </Row>
                </div>
                <br />
                <div id="truck-box">
                    <Row>
                        <Col md={6}>
                            <Image
                                src={P579}
                                width={'100%'}
                                fluid
                                rounded
                            />
                        </Col>
                        <Col>
                            <h3>Model 579</h3>
                            <p>The new Model 579. From a new, distinctive exterior design to a revamped interior, 
                                it was designed with purpose and to be driven with passion. With improved aerodynamics 
                                combined with cutting-edge technology, the New Model 579 isn’t just sleeker, it’s smarter. </p>
                            <ul>
                                <li>Enhanced aerodynamics, improved fuel economy</li>
                                <li>New and improved lighting packages</li>
                                <li>State of the art, class-leading driving features</li>
                                <li>Best in class driver comfort features</li>
                                <li>8 feet of head room, 70 cubic feet of storage</li>
                                <li>PACCA MX-13 and MX-11 power</li>
                            </ul>
                        </Col>
                    </Row>
                </div>
                <br />

                <div id="truck-box">
                    <Row>
                        <Col md={6}>
                            <Image
                                src={P589}
                                width={'100%'}
                                fluid
                                rounded
                            />
                        </Col>
                        <Col>
                            <h3>Model 589</h3>
                            <ul>
                                <li>Script & Spears Side Hood Emblem</li>
                                <li>Bright Cab/Sleeper Rockers</li>
                                <li>Polished Fendors/Skirt & Lower Hood Overlay</li>
                                <li>Door Pad Script & Spears Emblem</li>
                                <li>Seat Covers</li>
                                <li>Dash Emblem on Pull-Out Tray</li>
                            </ul>
                        </Col>
                    </Row>
                </div>
                <br />
            </Container>
            <BottomMenu />
        </div>
    );
}

export default Peterbilt;